import PropTypes from 'prop-types';
import React from 'react';

import CaseStudyPropTypes from '../models/CaseStudy/CaseStudyPropTypes';

import { Grid, GridItem } from '../ui-components';

import CaseStudyCard from './case-study-card';


const propTypes = {
  caseStudies: PropTypes.arrayOf(CaseStudyPropTypes).isRequired
};

/**
 * Component that renders a list of case studies in the featured style
 * 
 * !!NOTE: The design team would like to keep this component until after Phase 1. Do not delete.
 *
 * @component LegacyFeaturedCaseStudiesSection
 * 
 * @param {object} props
 * 
 * @prop {array} caseStudies
 */
const LegacyFeaturedCaseStudiesSection = props => {
  const { caseStudies } = props;

  const renderDefaultLayout = () => {
    return (
      <Grid gridGap={40}>
        {caseStudies?.map((caseStudy, index) => (
          <GridItem key={index} col={6} collg={12}>
            <CaseStudyCard caseStudy={caseStudy} displaySnippetText />
          </GridItem>
        ))}
      </Grid>
    );
  };

  const renderManyCaseStudies = () => {
    return (
      <Grid gridGap={40} mobileGap={24}>
        <GridItem col={6} collg={12}>
          <CaseStudyCard caseStudy={caseStudies[0]} displaySnippetText />
        </GridItem>
        <GridItem col={6} collg={12}>
          <Grid gridGap={24}>
            {caseStudies.slice(1).map((caseStudy, index) => (
              <GridItem key={index} col={12}>
                {caseStudies.length === 3 ? (
                  <CaseStudyCard caseStudy={caseStudy} smallDesktopCard displaySnippetText />
                ) : (
                  <CaseStudyCard caseStudy={caseStudy} smallDesktopCard />
                )}
              </GridItem>
            ))}
          </Grid>
        </GridItem>
      </Grid>
    );
  };

  if (caseStudies && caseStudies.length < 3) {
    return renderDefaultLayout();
  } else {
    return renderManyCaseStudies();
  }
};

LegacyFeaturedCaseStudiesSection.propTypes = propTypes;

export default LegacyFeaturedCaseStudiesSection;
